export const data = {
    "scenes": [
      {
        "id": "oriente-station",
        "name": "Oriente Station",
        "levels": [
          {
            "tileSize": 256,
            "size": 256,
            "fallbackOnly": true
          },
          {
            "tileSize": 512,
            "size": 512
          },
          {
            "tileSize": 512,
            "size": 1024
          },
          {
            "tileSize": 512,
            "size": 2048
          },
          {
            "tileSize": 512,
            "size": 4096
          }
        ],
        "faceSize": 4096,
        "initialViewParameters": {
          "pitch": 0,
          "yaw": 0,
          "fov": 1.5707963267948966
        },
        "linkHotspots": [
          {
            "yaw": 3.12678386676067,
            "pitch": -0.0076340532339251865,
            "rotation": 0,
            "target": "electricity-museum"
          }
        ],
        "infoHotspots": [
          {
            "yaw": -0.00038049728702915786,
            "pitch": 0.014985751462495145,
            "title": "Oriente Station",
            "text": "The Oriente Station is one of the most important bus and train stations in the city. Designed by the Spanish architect and engineer Santiago Calatrava, it has an enormous metal skeleton that covers the eight train lines and its platforms. Finished in 1998 to serve the Expo’98 and, later, the Parque das Nações area, in its surroundings are companies, services, hotels, bars, animation, as well as the well known Vasco da Gama shopping centre."
          }
        ]
      },
      {
        "id": "electricity-museum",
        "name": "Electricity Museum",
        "levels": [
          {
            "tileSize": 256,
            "size": 256,
            "fallbackOnly": true
          },
          {
            "tileSize": 512,
            "size": 512
          },
          {
            "tileSize": 512,
            "size": 1024
          },
          {
            "tileSize": 512,
            "size": 2048
          },
          {
            "tileSize": 512,
            "size": 4096
          }
        ],
        "faceSize": 4096,
        "initialViewParameters": {
          "pitch": 0,
          "yaw": 0,
          "fov": 1.5707963267948966
        },
        "linkHotspots": [
          {
            "yaw": -2.3152585099587224,
            "pitch": 0.045251205931975846,
            "rotation": 5.497787143782138,
            "target": "jeronimos"
          }
        ],
        "infoHotspots": [
          {
            "yaw": -0.1606464893205768,
            "pitch": -0.17433292221669205,
            "title": "Boilers Room",
            "text": "In the impressive Boilers Room at the Electricity Museum we find four large boilers of about 100 feet tall, with their respective control panels, air and fuel circuits, ventilators, etc. Boiler number 15 has been musealised and visitors may go in and discover its structure and internal component: conveyor belt, Bailey walls, naphtha burners, water heating tubes, and so on."
          }
        ]
      },
      {
        "id": "jeronimos",
        "name": "Jerónimos Monastery",
        "levels": [
          {
            "tileSize": 256,
            "size": 256,
            "fallbackOnly": true
          },
          {
            "tileSize": 512,
            "size": 512
          },
          {
            "tileSize": 512,
            "size": 1024
          },
          {
            "tileSize": 512,
            "size": 2048
          },
          {
            "tileSize": 512,
            "size": 4096
          }
        ],
        "faceSize": 4096,
        "initialViewParameters": {
          "pitch": 0,
          "yaw": 0,
          "fov": 1.5707963267948966
        },
        "linkHotspots": [
          {
            "yaw": -0.775981148319735,
            "pitch": 0.2661802812323746,
            "rotation": 0,
            "target": "oriente-station"
          }
        ],
        "infoHotspots": [
          {
            "yaw": 0.5350080558065997,
            "pitch": 0.24525106321929435,
            "title": "Jerónimos Monastery",
            "text": "The Jerónimos Monastery cloister is a pleasant and serene place intended to foster monks’ prayers and meditation. Its manuelin decoration features decorative religious, nautical and royal elements, as well as vegetal motifs. Since 1985, the tomb of the poet Fernando Pessoa rests in the north wing of the cloister’s ground floor."
          }
        ]
      }
    ],
    "name": "Sample Tour",
    "settings": {
        "mouseViewMode": "drag",
        "autorotateEnabled": true,
        "fullscreenButton": true,
        "viewControlButtons": true
    }
};
